export const STATUS_ACTIVE = 1;
export const STATUS_INACTIVE = 0;

export const PROCESS_STATUS_REJECTED = 1;
export const PROCESS_STATUS_PUBLISHED = 2;
export const PROCESS_STATUS_AUTHOR_REVISION = 3;
export const PROCESS_STATUS_IN_PROGRESS = 4;

export const ASSIGN_STATUS_NEW = 1;
export const ASSIGN_STATUS_ACCEPTED = 2;
export const ASSIGN_STATUS_REJECTED = 3;
export const ASSIGN_STATUS_COMPLETED = 4;

export const RESULT_TYPE_STATUS = 'phase';
export const RESULT_TYPE_PROCESS_STATUS = 'process_status';
export const RESULT_TYPE_AUTHOR_DECISION = 'author_decision';

export const INVITATION_STATUS_INVITED = 'invited';
export const INVITATION_STATUS_DECLINED = 'declined';
export const INVITATION_STATUS_ACCEPTED = 'accepted';

export const PROCESS_STATUSES = {
    [PROCESS_STATUS_REJECTED]: 'Rejected',
    [PROCESS_STATUS_PUBLISHED]: 'Publication Process',
    [PROCESS_STATUS_AUTHOR_REVISION]: 'Author’s revision',
    [PROCESS_STATUS_IN_PROGRESS]: 'In progress'
};

export const PROCESS_STATUS_CLASSES = {
    [PROCESS_STATUS_REJECTED]: 'reject',
    [PROCESS_STATUS_PUBLISHED]: 'reject',
    [PROCESS_STATUS_AUTHOR_REVISION]: 'authorrevision',
    [PROCESS_STATUS_IN_PROGRESS]: 'inprogress'
};

export const RESULT_TYPE_SUFFIX = {
    [RESULT_TYPE_STATUS]: 'phase',
    [RESULT_TYPE_PROCESS_STATUS]: 'status',
    [RESULT_TYPE_AUTHOR_DECISION]: 'decision',
};



// WEBPACK FOOTER //
// ./src/constants/status.js